<template>
    <div
        role="status"
        aria-live="polite"
        :aria-label="localizations[lang].loading"
        class="LoadingSpinner min-w-5"
        :class="{
            'positioned top-[20%]': position === 'top',
            'positioned bottom-[20%]': position === 'bottom',
        }"
    >
        <svg
            aria-hidden="true"
            :width="width"
            :height="height"
            :class="{ notCentered: notCentered }"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        width: {
            type: String,
            required: false,
            default: '65px',
        },
        height: {
            type: String,
            required: false,
            default: '65px',
        },
        notCentered: {
            type: Boolean,
            required: false,
            default: false,
        },
        position: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
};
</script>

<style lang="scss" scoped>
.LoadingSpinner {
    &.positioned {
        @apply fixed left-1/2 z-2 -translate-x-1/2;
    }

    svg {
        @apply fixed inset-0 z-999 m-auto h-[3em] w-[3em];
    }

    svg.notCentered {
        @apply static h-auto w-auto;
    }

    $offset: 187;
    $duration: 1.4s;

    .path {
        stroke: #bdbdbd;
        stroke-dasharray: $offset;
        stroke-dashoffset: 0;
        transform-origin: center;
        animation: dash $duration ease-in-out infinite;
    }

    @keyframes dash {
        0% {
            stroke-dashoffset: $offset;
        }
        50% {
            stroke-dashoffset: calc($offset / 4);
            transform: rotate(135deg);
        }
        100% {
            stroke-dashoffset: $offset;
            transform: rotate(450deg);
        }
    }
}
</style>
